import { AdvancedTourStep } from '../shared-types';
import { TaskTourProps } from './task-tour-props';

export function getDelayTourSteps({ defaultStyles }: Readonly<TaskTourProps>): AdvancedTourStep[] {
	return [
		{
			id: 'delay-ms',
			selector: '[data-tour="delay-ms"]',
			content: 'Required: Sets the amount of time in milliseconds that the task should wait for.',
		},
		{
			id: 'delay-multiplier',
			selector: '[data-tour="delay-multiplier"]',
			content:
				'Required: Sets the multiplier that will be applied to the "Delay" time. So the equation will be "DelayTime x Multiplier". This can be used if the delay time needs to scale according to some variable factor.',
		},
	].map(tourItem => ({ ...tourItem, styles: defaultStyles }));
}
